import React from "react";

import HospitalMapping from "@components/hospitalMapping/hospitalMapping";
import "./hospitalListAndCM.scss";
import { useHospitalMappingStore } from "@stores/useHospitalMappingStore";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { HOSPITAL_LIST_AND_CM_USER_OPENED_FROM, routeMap } from "@utils/constants";
import classNames from "classnames";

const HospitalListAndCmPage = (props: any) => {

  const navigate = useNavigate();

  const isBackButtonDisplay = useHospitalMappingStore((state) => state.isBackButtonDisplay);
  const setIsBackButtonDisplay = useHospitalMappingStore((state) => state.setIsBackButtonDisplay);
  const setShowHospitalistsModal = useHospitalMappingStore((state) => state.setShowHospitalistsModal);
  const hospitalMappingEditModeOpenedFrom = useHospitalMappingStore((state) => state.hospitalMappingEditModeOpenedFrom);
  const setShowMemberDetailsModal = useHospitalMappingStore((state) => state.setShowMemberDetailsModal);


  const goToPrvPage = () => {
    setIsBackButtonDisplay(false);
    if (hospitalMappingEditModeOpenedFrom === HOSPITAL_LIST_AND_CM_USER_OPENED_FROM.Members) {
      // setHospitalMappingEditModeOpenedFrom(HOSPITAL_LIST_AND_CM_USER_OPENED_FROM.None);
      setShowMemberDetailsModal(true);
      navigate(routeMap.members);
    }

    if (hospitalMappingEditModeOpenedFrom === HOSPITAL_LIST_AND_CM_USER_OPENED_FROM.memberDetailADT) {
      // setHospitalMappingEditModeOpenedFrom(HOSPITAL_LIST_AND_CM_USER_OPENED_FROM.None);
      setShowHospitalistsModal(true);
      navigate(routeMap.memberProfile , { state: { from: routeMap.dashboard, fromLabel : "Reports / CM Contact Matrix"}});
    }
  };

  return (
    <div className="hospitalListAndCmPage">
      <div className="hospitalListAndCmPage__header">
        <div className="hospitalListAndCmPage__header__page-name">
        {
            isBackButtonDisplay ? (
                <div className="hospitalListAndCmPage__header__back-button">
                <Button type="text" shape="circle" size={"large"} className="hospitalListAndCmPage__header__back-button__btn" onClick={() => {goToPrvPage()}}>
                  <i className="hospitalListAndCmPage__header__back-button__btn__icon icon-arrow-left"></i>
                </Button>
              </div>
            ) : null
        }
          <div className={classNames({
            "hospitalListAndCmPage__header__directory-path": true,
            "hospitalListAndCmPage__header__directory-path-hide": !(hospitalMappingEditModeOpenedFrom === HOSPITAL_LIST_AND_CM_USER_OPENED_FROM.Members || hospitalMappingEditModeOpenedFrom === HOSPITAL_LIST_AND_CM_USER_OPENED_FROM.memberDetailADT)
          })}>HealthEM.AI / CM Contact Matrix</div></div>
      </div>
      <div className="hospitalListAndCmPage__container">
        <HospitalMapping currentMode="edit" />
      </div>
    </div>
  );
};

export default HospitalListAndCmPage;
